<template>
  <BaseModal
    :visible="visible"
    :enable-bg-close="enableBgClose"
    :fully-customisable="fullyCustomisable"
    @click-on-close="handleClose"
  >
    <div class="group-coaching-modal">
      <h2>Your First <span class="highlight">Live Coaching Session</span> Is Coming Up</h2>
      <h3>This Thursday at 2pm EST / 11am PST</h3>

      <p>Get live guidance, real answers, and support from certified career coaches and people who get it.</p>

      <div class="modal-points">
        <p>✅ Check your email to make sure it's on your calendar</p>
        <p>👨‍💻 Can't make it? No worries — you'll get the full recording and materials after.</p>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue"
import BaseModal from "@/components/base/BaseModal.vue"

defineProps({
  visible: { type: Boolean, required: true },
  enableBgClose: { type: Boolean, default: false },
  fullyCustomisable: { type: Boolean, default: true }
})

const emit = defineEmits(["close"])

function handleClose() {
  emit("close")
}
</script>

<style scoped lang="scss">
.group-coaching-modal {
  padding: 48px 24px;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
    line-height: 1.2;
    color: $black;

    .highlight {
      color: $white;
      background-image: $blue-purple-gradient;
      padding: 0 8px;
      border-radius: 14px;
      white-space: nowrap;
    }
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 24px;
    color: $black500;
  }

  p {
    text-align: left;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 24px;
    color: $black600;
  }

  .modal-points {
    margin-top: 24px;

    p {
      font-size: 16px;
      line-height: 1.2;
      margin-bottom: 2px;
      color: #333;
      text-align: left;
    }
  }
}
</style>
